import createFetchClient from "openapi-fetch";
import { UserAuthReq, MemberRegistrationReq, paths } from "@doors/api-client";

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

// register a new user
export async function register(req: MemberRegistrationReq): Promise<string> {
  const res = await fetch("/api/v1/user/register", {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(req)
  });
  if (res.status == 200) {
    return "";
  }
  return "Something went wrong, please try again later";
}

// attempt to log in
export async function login(
  req: UserAuthReq
): Promise<{ success: boolean; jwt: string | null }> {
  const res = await fetch("/api/v1/user/authenticate", {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(req)
  });
  return {
    success: res.ok,
    jwt: res.ok ? await res.text() : null
  };
}

export const fetchClient = createFetchClient<paths>({ baseUrl: "/" });
